import Dispatcher from '../core/Dispatcher';
import { Constants } from '../constants';

//Token
let jwt = localStorage.getItem('jwt');

const CurrenciesApiUtils = {
  get: function(url) {
    Promise.resolve(
      $.ajax({
        url: url,
        type: 'GET',
        beforeSend: (req) => {
          req.setRequestHeader("Authorization", "bearer " + localStorage.getItem('jwt'));
        }
      }))
      .then(function(data){
        Dispatcher.handleViewAction({
          actionType: Constants.ActionCurrencies.LOAD_CURRENCIES_SUCCESS,
          currencies: data
        });
      })
      .catch(function(err){
        Dispatcher.handleViewAction({
          actionType: Constants.ActionCurrencies.LOAD_CURRENCIES_ERROR,
          err: err
        });
      })
  }
}

export default CurrenciesApiUtils
